
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import Group from 'vux/src/components/group/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Box from 'vux/src/components/box/index.vue'


export default {

components: {
XHeader,
Box,
Group,
XTextarea,
XButton
},
/**计算属性 将状态表中的数据 映射出来*/
computed: {},
data() {
return {
isWechat: ____isWechatBrowser(),
invoiceInfo: {
__id: "",
note: ""
}
};
},
created() {},
activated() {
var $self = this;
var __id = $self.$route.params.id;
$self.loadInoiceInfo(__id);
},
/**计算属性 将状态表中的数据 映射出来*/
computed: {},
/**初始化的时候调用  类似于 ready */
mounted() {
var $self = this;

},
methods: {
pageGoBack() {
var $self = this;
$self.$router.go(-1);
},
loadInoiceInfo(invoiceId) {
var $self = this;
$self.$webapi
.oneInvoice({
invoiceId: invoiceId
})
.then(res => {
$self.$clog(res.data);
if (res.data.status == 1) {
var resData = res.data.result;

$self.invoiceInfo = {
__id: invoiceId,
note: resData.ext2
};
}
});
},
save() {
var $self = this;
var parms = {
invoiceId: $self.invoiceInfo.__id,
remark: $self.invoiceInfo.note
};

$self.$webapi.updatePersonalRemark(parms).then(res => {
$self.$clog(res.data);
if (res.data.status == 1) {
var resData = res.data.result;
$self.$vux.alert.show({
title: this.$t("操作成功"),
content: this.$t("票据信息保存成功"), //this.$t("编辑增值税发票保存成功"),
onShow() {
},
onHide() {
$self.$router.replace({
path: "/invoice/detail/" + $self.invoiceInfo.__id,
query: { p_refresh: "1" }
});
}
});
} else {
$self.$vux.alert.show({
title: this.$t("操作失败"),
content: res.data.msg,
onShow() {},
onHide() {
$self.$router.replace({
path: "/invoice/detail/" + $self.invoiceInfo.__id,
query: { p_refresh: "1" }
});
}
});
}
});
}
}
};
